import { connect } from 'react-redux';
import get from 'lodash/get';

import { getIsCommissionShop, getIsShop } from '../../../auth/selectors';

// eslint-disable-next-line import/prefer-default-export
export const withPaymentInfoSetupStatus = connect(
  (state) => {
    const isCommissionShop = getIsShop(state) && getIsCommissionShop(state);
    const shouldCheckBankAccountSetup = isCommissionShop;

    const hasBankAccount = !!get(state, 'auth.activeShop.bankAccountId');

    return {
      isPaymentInfoSetup: !shouldCheckBankAccountSetup || hasBankAccount,
    };
  }
);
